
var $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8 = /*#__PURE__*/ function(PieceType) {
    PieceType["UNIT"] = "u";
    PieceType["LARGE"] = "l";
    PieceType["LONG"] = "o";
    PieceType["SQUARE"] = "s";
    return PieceType;
}({});


class $11d0b7b70f8cbd15$export$13807d9ee5a34a42 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    clone() {
        return new $11d0b7b70f8cbd15$export$13807d9ee5a34a42(this.x, this.y);
    }
}


class $8c7a0ac04a6fb85e$export$7de691058ff51291 {
    constructor(position, pieceType, isMain){
        this.position = position;
        this.pieceType = pieceType;
        this.isMain = isMain;
        this.positions = new Array();
        this.positions.push(position);
        switch(pieceType){
            case (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).UNIT:
                break;
            case (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).LARGE:
                this.positions.push(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(position.x + 1, position.y));
                break;
            case (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).LONG:
                this.positions.push(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(position.x, position.y + 1));
                break;
            case (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).SQUARE:
                this.positions.push(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(position.x, position.y + 1));
                this.positions.push(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(position.x + 1, position.y));
                this.positions.push(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(position.x + 1, position.y + 1));
                break;
        }
    }
    move(deltaX, deltaY) {
        // no need to move  this.position, because it is already in this.positions
        this.positions.forEach((p)=>{
            p.x += deltaX;
            p.y += deltaY;
        });
    }
    isAt(x, y) {
        return this.positions.some((p)=>p.x === x && p.y === y);
    }
    isAtExact(x, y) {
        return this.position.x === x && this.position.y === y;
    }
    clone() {
        return new $8c7a0ac04a6fb85e$export$7de691058ff51291(this.position.clone(), this.pieceType, this.isMain);
    }
}




class $8365d258f746f9fd$export$985739bfa5723e08 {
    constructor(pieces, width = 4, height = 5, lastPieceMove = null, distance = 0){
        this.pieces = pieces;
        this.width = width;
        this.height = height;
        this.lastPieceMove = lastPieceMove;
        this.distance = distance;
        this.parent = null;
        this.parentMove = null;
    }
    get parentGame() {
        return this.parent;
    }
    get moveFromParent() {
        return this.parentMove;
    }
    setParent(parent, move) {
        this.parent = parent;
        this.parentMove = move;
    }
    canMoveTo(piece, deltaX, deltaY) {
        if (!piece.positions.every((p)=>{
            const newX = p.x + deltaX;
            const newY = p.y + deltaY;
            if (newX < 0 || newX >= this.width) return false;
            if (newY < 0 || newY >= this.height) return false;
            return true;
        })) return false;
        return piece.positions.every((p)=>{
            const x = p.x + deltaX;
            const y = p.y + deltaY;
            return this.pieces.every((p)=>p === piece || !p.isAt(x, y));
        });
    }
    isWinningGame(targetX, targetY) {
        return this.pieces.some((p)=>p.isMain && p.isAtExact(targetX, targetY));
    }
    gethash(withLastPieceMove) {
        const occupations = new Array();
        for(let i = 0; i < this.width * this.height; i++)occupations.push(".");
        this.pieces.forEach((p)=>{
            occupations[p.position.x + p.position.y * this.width] = p.isMain ? p.pieceType.toUpperCase() : p.pieceType;
        });
        const lastPieceMove = this.lastPieceMove;
        if (withLastPieceMove && null !== lastPieceMove) occupations.push(lastPieceMove.position.x + "," + lastPieceMove.position.y);
        return occupations.join("");
    }
    static getGridFromHash(hash, width, height) {
        const grid = [];
        for(let y = 0; y < height; y++)grid.push(hash.slice(y * width, (y + 1) * width));
        return grid.join("\n");
    }
    static fromHash(hash, width = 4, height = 5) {
        const pieces = new Array();
        hash.split("").forEach((c, i)=>{
            if (c === ".") return;
            const x = i % width;
            const y = Math.floor(i / width);
            const pos = new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(x, y);
            const allowedPieces = Object.values((0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8));
            const pieceType = allowedPieces.find((p)=>p === c.toLowerCase()) || null;
            if (pieceType === null) return;
            pieces.push(new (0, $8c7a0ac04a6fb85e$export$7de691058ff51291)(pos, pieceType, c === c.toUpperCase()));
        });
        return new $8365d258f746f9fd$export$985739bfa5723e08(pieces, width, height);
    }
    cloneAndMove(piece, deltaX, deltaY, distance) {
        let lastPieceMove = null;
        const pieces = this.pieces.map((p)=>{
            const p2 = p.clone();
            if (p === piece) {
                p2.move(deltaX, deltaY);
                lastPieceMove = p2;
            }
            return p2;
        });
        return new $8365d258f746f9fd$export$985739bfa5723e08(pieces, this.width, this.height, lastPieceMove, distance);
    }
}


const $731f0200f14e0930$var$SAVE_VERSION = 1;
function $731f0200f14e0930$export$bd27afecf6d17d36(progress) {
    return {
        version: $731f0200f14e0930$var$SAVE_VERSION,
        levels: [
            ...progress
        ].sort(([firstId], [secondId])=>firstId.localeCompare(secondId)).map(([id, actions])=>({
                id: id,
                actions: actions
            }))
    };
}
function $731f0200f14e0930$var$isValidLevelId(value) {
    return typeof value === "string" && value.length > 0 && value.trim() === value;
}
function $731f0200f14e0930$var$isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $731f0200f14e0930$var$isNonNegativeInteger(value) {
    return typeof value === "number" && Number.isInteger(value) && value >= 0;
}
function $731f0200f14e0930$export$f70ecbe02728c625(value) {
    if (!$731f0200f14e0930$var$isRecord(value)) throw new Error("The save file must contain an object");
    if (value.version !== $731f0200f14e0930$var$SAVE_VERSION || !Array.isArray(value.levels)) throw new Error("Unsupported save file version");
    const progress = new Map();
    for (const level of value.levels){
        if (!$731f0200f14e0930$var$isRecord(level)) throw new Error("Every level progress must be an object");
        const id = level.id;
        const actions = level.actions;
        if (!$731f0200f14e0930$var$isValidLevelId(id) || !$731f0200f14e0930$var$isNonNegativeInteger(actions)) throw new Error("Every level progress must contain a valid score");
        progress.set(id, actions);
    }
    return progress;
}
function $731f0200f14e0930$export$fb183d491ecd1d5e(progress) {
    return JSON.stringify($731f0200f14e0930$export$bd27afecf6d17d36(progress), null, 2);
}
function $731f0200f14e0930$export$8440180bf207bbae(level, progress) {
    const actions = progress.get(level.id);
    if (actions === undefined) return "unresolved";
    if (level.level.minimumMoves !== null && actions === level.level.minimumMoves) return "optimal";
    return "solved";
}
function $731f0200f14e0930$export$580df88938249f5a(level, progress) {
    const status = $731f0200f14e0930$export$8440180bf207bbae(level, progress);
    const marker = status === "optimal" ? "\uD83D\uDFE2" : status === "solved" ? "\uD83D\uDFE1" : "";
    const className = status === "optimal" ? "level-optimal" : status === "solved" ? "level-solved" : "";
    const actions = progress.get(level.id);
    const score = actions === undefined ? "" : ` \u{2014} ${actions} action${actions === 1 ? "" : "s"}`;
    const markerPrefix = marker === "" ? "" : `${marker} `;
    const name = level.level.name ?? "Niveau sans nom";
    return {
        status: status,
        marker: marker,
        className: className,
        label: `${markerPrefix}${level.level.level}. ${name}${score}`
    };
}
function $731f0200f14e0930$export$a9cbe8b7f5aeb428(progress, levelId, actions) {
    const previousBest = progress.get(levelId);
    if (previousBest !== undefined && previousBest <= actions) return false;
    progress.set(levelId, actions);
    return true;
}
function $731f0200f14e0930$export$12070480cc9bc09b(levels, progress) {
    return levels.find((level)=>$731f0200f14e0930$export$8440180bf207bbae(level, progress) === "unresolved") ?? levels.find((level)=>$731f0200f14e0930$export$8440180bf207bbae(level, progress) !== "optimal") ?? levels[0];
}






const $e34a31c9fa062692$var$PIECE_TYPES = new Map([
    [
        "1,1",
        (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).UNIT
    ],
    [
        "1,2",
        (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).LARGE
    ],
    [
        "2,1",
        (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).LONG
    ],
    [
        "2,2",
        (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).SQUARE
    ]
]);
async function $e34a31c9fa062692$export$821a5558a0f47a0a(filePath, loadText = $e34a31c9fa062692$var$loadFromBrowser) {
    try {
        const path = $e34a31c9fa062692$var$getStaticFilePath(filePath);
        const data = JSON.parse(await loadText(path));
        return $e34a31c9fa062692$export$8297bb3ca9887f15(data);
    } catch (error) {
        const reason = error instanceof Error ? error.message : String(error);
        console.error(`Unable to read levels from "${filePath}": ${reason}`);
        return [];
    }
}
function $e34a31c9fa062692$export$8f449e88c069ccfc(filePath) {
    return $e34a31c9fa062692$export$821a5558a0f47a0a(filePath);
}
function $e34a31c9fa062692$var$getStaticFilePath(filePath) {
    const path = filePath.replace(/\\/g, "/").replace(/^\.\//, "").replace(/^static\//, "");
    const parts = path.split("/");
    if (path.length === 0 || parts.some((part)=>part === "" || part === "." || part === "..")) throw new Error("The level file path must point inside the static directory");
    return path;
}
const $e34a31c9fa062692$var$loadFromBrowser = async (filePath)=>{
    const response = await fetch(filePath);
    if (!response.ok) throw new Error(`HTTP ${response.status} while loading static/${filePath}`);
    return response.text();
};
function $e34a31c9fa062692$export$8297bb3ca9887f15(data) {
    if (!Array.isArray(data) || data.length === 0) throw new Error("The JSON root must be a non-empty array of levels");
    const levels = data.map((value, index)=>$e34a31c9fa062692$var$parseLevel(value, index));
    if (new Set(levels.map((level)=>level.level)).size !== levels.length) throw new Error("Level numbers must be unique");
    return levels.sort((left, right)=>left.level - right.level);
}
function $e34a31c9fa062692$var$parseLevel(value, index) {
    const record = $e34a31c9fa062692$var$asRecord(value, `Level at index ${index}`);
    const level = $e34a31c9fa062692$var$asPositiveInteger(record.level, `Level at index ${index}.level`);
    const name = $e34a31c9fa062692$var$asOptionalName(record.name, `Level ${level}.name`);
    const minimumMoves = $e34a31c9fa062692$var$asMinimumMoves(record.minimumMoves, `Level ${level}.minimumMoves`);
    const [height, width] = $e34a31c9fa062692$var$asPair(record.boardSize, `Level ${level}.boardSize`, true);
    const [escapeY, escapeX] = $e34a31c9fa062692$var$asPair(record.escapePoint, `Level ${level}.escapePoint`, false);
    if (!Array.isArray(record.blocks) || record.blocks.length === 0) throw new Error(`Level ${level}.blocks must be a non-empty array`);
    const pieces = record.blocks.map((block, blockIndex)=>$e34a31c9fa062692$var$parsePiece(block, level, blockIndex));
    if (pieces.filter((piece)=>piece.isMain).length !== 1) throw new Error(`Level ${level} must contain exactly one 2x2 main piece`);
    $e34a31c9fa062692$var$validateGeometry(pieces, width, height, level);
    if (escapeX + 1 >= width || escapeY + 1 >= height) throw new Error(`Level ${level}.escapePoint places the main piece outside the board`);
    return {
        level: level,
        name: name,
        game: new (0, $8365d258f746f9fd$export$985739bfa5723e08)(pieces, width, height),
        minimumMoves: minimumMoves,
        escapePoint: new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(escapeX, escapeY)
    };
}
function $e34a31c9fa062692$var$parsePiece(value, level, index) {
    const label = `Level ${level}.blocks[${index}]`;
    const block = $e34a31c9fa062692$var$asRecord(value, label);
    const [shapeHeight, shapeWidth] = $e34a31c9fa062692$var$asPair(block.shape, `${label}.shape`, true);
    const [positionY, positionX] = $e34a31c9fa062692$var$asPair(block.position, `${label}.position`, false);
    const pieceType = $e34a31c9fa062692$var$PIECE_TYPES.get(`${shapeHeight},${shapeWidth}`);
    if (pieceType === undefined) throw new Error(`${label}.shape is not supported`);
    return new (0, $8c7a0ac04a6fb85e$export$7de691058ff51291)(new (0, $11d0b7b70f8cbd15$export$13807d9ee5a34a42)(positionX, positionY), pieceType, pieceType === (0, $af1ab7dc7c9bd2bd$export$6c0d870ba48c6db8).SQUARE);
}
function $e34a31c9fa062692$var$validateGeometry(pieces, width, height, level) {
    const occupied = new Set();
    pieces.forEach((piece, pieceIndex)=>piece.positions.forEach((position)=>{
            if (position.x < 0 || position.x >= width || position.y < 0 || position.y >= height) throw new Error(`Level ${level}.blocks[${pieceIndex}] exceeds the board`);
            const key = `${position.x},${position.y}`;
            if (occupied.has(key)) throw new Error(`Level ${level}.blocks[${pieceIndex}] overlaps another piece`);
            occupied.add(key);
        }));
}
function $e34a31c9fa062692$var$isJsonRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $e34a31c9fa062692$var$asRecord(value, label) {
    if (!$e34a31c9fa062692$var$isJsonRecord(value)) throw new Error(`${label} must be an object`);
    return value;
}
function $e34a31c9fa062692$var$asPair(value, label, positive) {
    if (!Array.isArray(value) || value.length !== 2) throw new Error(`${label} must contain exactly two integers`);
    const first = value[0];
    const second = value[1];
    const valid = (item)=>typeof item === "number" && Number.isInteger(item) && (positive ? item > 0 : item >= 0);
    if (!valid(first) || !valid(second)) throw new Error(`${label} must contain ${positive ? "positive" : "non-negative"} integers`);
    return [
        first,
        second
    ];
}
function $e34a31c9fa062692$var$asOptionalName(value, label) {
    if (value === undefined) return null;
    if (typeof value !== "string" || value.trim().length === 0) throw new Error(`${label} must be a non-empty string`);
    return value.trim();
}
function $e34a31c9fa062692$var$asMinimumMoves(value, label) {
    if (value === null) return null;
    if (typeof value !== "number" || !Number.isInteger(value) || value <= 0) throw new Error(`${label} must be null or a positive integer`);
    return value;
}
function $e34a31c9fa062692$var$asPositiveInteger(value, label) {
    if (typeof value !== "number" || !Number.isInteger(value) || value <= 0) throw new Error(`${label} must be a positive integer`);
    return value;
}


const $b4e14b6b8da86996$var$COLLECTIONS = [
    {
        file: "hrd-games.json",
        label: "Classiques HRD"
    },
    {
        file: "levels.json",
        label: "Progression"
    }
];
const $b4e14b6b8da86996$var$SAVE_STORAGE_KEY = "klotski-progress";
function $b4e14b6b8da86996$var$elementById(id, elementType) {
    const element = document.getElementById(id);
    if (!(element instanceof elementType)) throw new Error(`Missing or invalid #${id} in index.html`);
    return element;
}
const $b4e14b6b8da86996$var$board = $b4e14b6b8da86996$var$elementById("board", HTMLDivElement);
const $b4e14b6b8da86996$var$levelSelect = $b4e14b6b8da86996$var$elementById("level-select", HTMLSelectElement);
const $b4e14b6b8da86996$var$initialCount = $b4e14b6b8da86996$var$elementById("initial-count", HTMLElement);
const $b4e14b6b8da86996$var$playedCount = $b4e14b6b8da86996$var$elementById("played-count", HTMLElement);
const $b4e14b6b8da86996$var$remainingCount = $b4e14b6b8da86996$var$elementById("remaining-count", HTMLElement);
const $b4e14b6b8da86996$var$projectedCount = $b4e14b6b8da86996$var$elementById("projected-count", HTMLElement);
const $b4e14b6b8da86996$var$hintButton = $b4e14b6b8da86996$var$elementById("hint-button", HTMLButtonElement);
const $b4e14b6b8da86996$var$resetButton = $b4e14b6b8da86996$var$elementById("reset-button", HTMLButtonElement);
const $b4e14b6b8da86996$var$status = $b4e14b6b8da86996$var$elementById("status", HTMLParagraphElement);
const $b4e14b6b8da86996$var$exportSaveButton = $b4e14b6b8da86996$var$elementById("export-save-button", HTMLButtonElement);
const $b4e14b6b8da86996$var$importSaveButton = $b4e14b6b8da86996$var$elementById("import-save-button", HTMLButtonElement);
const $b4e14b6b8da86996$var$saveFileInput = $b4e14b6b8da86996$var$elementById("save-file-input", HTMLInputElement);
const $b4e14b6b8da86996$var$victoryDialog = $b4e14b6b8da86996$var$elementById("victory-dialog", HTMLDialogElement);
const $b4e14b6b8da86996$var$victorySummary = $b4e14b6b8da86996$var$elementById("victory-summary", HTMLParagraphElement);
const $b4e14b6b8da86996$var$nextLevelButton = $b4e14b6b8da86996$var$elementById("next-level-button", HTMLButtonElement);
const $b4e14b6b8da86996$var$closeVictoryButton = $b4e14b6b8da86996$var$elementById("close-victory-button", HTMLButtonElement);
let $b4e14b6b8da86996$var$solver = null;
let $b4e14b6b8da86996$var$choices = [];
let $b4e14b6b8da86996$var$selectedLevel = null;
let $b4e14b6b8da86996$var$game = null;
let $b4e14b6b8da86996$var$playedActions = 0;
let $b4e14b6b8da86996$var$remainingActions = null;
let $b4e14b6b8da86996$var$lastPieceIndex = null;
let $b4e14b6b8da86996$var$hint = null;
let $b4e14b6b8da86996$var$hintVisible = false;
let $b4e14b6b8da86996$var$solutionPath = [];
let $b4e14b6b8da86996$var$solving = false;
let $b4e14b6b8da86996$var$latestRequestId = 0;
let $b4e14b6b8da86996$var$drag = null;
let $b4e14b6b8da86996$var$progress = $b4e14b6b8da86996$var$loadLocalProgress();
function $b4e14b6b8da86996$var$cloneGame(source) {
    return new (0, $8365d258f746f9fd$export$985739bfa5723e08)(source.pieces.map((piece)=>piece.clone()), source.width, source.height);
}
function $b4e14b6b8da86996$var$setStatus(message) {
    $b4e14b6b8da86996$var$status.textContent = message;
}
function $b4e14b6b8da86996$var$errorMessage(error) {
    return error instanceof Error ? error.message : String(error);
}
function $b4e14b6b8da86996$var$loadLocalProgress() {
    try {
        const saved = localStorage.getItem($b4e14b6b8da86996$var$SAVE_STORAGE_KEY);
        return saved === null ? new Map() : (0, $731f0200f14e0930$export$f70ecbe02728c625)(JSON.parse(saved));
    } catch (error) {
        console.error(`Impossible de charger la progression : ${$b4e14b6b8da86996$var$errorMessage(error)}`);
        return new Map();
    }
}
function $b4e14b6b8da86996$var$persistLocalProgress() {
    localStorage.setItem($b4e14b6b8da86996$var$SAVE_STORAGE_KEY, (0, $731f0200f14e0930$export$fb183d491ecd1d5e)($b4e14b6b8da86996$var$progress));
}
function $b4e14b6b8da86996$var$currentChoice() {
    return $b4e14b6b8da86996$var$choices.find((choice)=>choice.id === $b4e14b6b8da86996$var$levelSelect.value);
}
function $b4e14b6b8da86996$var$updateLevelOption(option, choice) {
    const presentation = (0, $731f0200f14e0930$export$580df88938249f5a)(choice, $b4e14b6b8da86996$var$progress);
    option.textContent = presentation.label;
    option.className = presentation.className;
}
function $b4e14b6b8da86996$var$refreshLevelOptions() {
    for (const option of Array.from($b4e14b6b8da86996$var$levelSelect.options)){
        const choice = $b4e14b6b8da86996$var$choices.find((item)=>item.id === option.value);
        if (choice !== undefined) $b4e14b6b8da86996$var$updateLevelOption(option, choice);
    }
}
function $b4e14b6b8da86996$var$markCurrentLevelSolved() {
    const choice = $b4e14b6b8da86996$var$currentChoice();
    if (choice === undefined) return;
    if (!(0, $731f0200f14e0930$export$a9cbe8b7f5aeb428)($b4e14b6b8da86996$var$progress, choice.id, $b4e14b6b8da86996$var$playedActions)) return;
    $b4e14b6b8da86996$var$refreshLevelOptions();
    try {
        $b4e14b6b8da86996$var$persistLocalProgress();
    } catch (error) {
        console.error(`Impossible de sauvegarder la progression : ${$b4e14b6b8da86996$var$errorMessage(error)}`);
    }
}
function $b4e14b6b8da86996$var$preferredChoice() {
    return (0, $731f0200f14e0930$export$12070480cc9bc09b)($b4e14b6b8da86996$var$choices, $b4e14b6b8da86996$var$progress);
}
function $b4e14b6b8da86996$var$showVictoryScreen() {
    const choice = $b4e14b6b8da86996$var$currentChoice();
    if (choice === undefined) return;
    $b4e14b6b8da86996$var$markCurrentLevelSolved();
    const actionLabel = $b4e14b6b8da86996$var$playedActions === 1 ? "action" : "actions";
    const target = $b4e14b6b8da86996$var$selectedLevel?.minimumMoves === null || $b4e14b6b8da86996$var$selectedLevel === null ? "" : ` Objectif initial : ${$b4e14b6b8da86996$var$selectedLevel.minimumMoves}.`;
    $b4e14b6b8da86996$var$victorySummary.textContent = `Niveau r\xe9solu en ${$b4e14b6b8da86996$var$playedActions} ${actionLabel}.${target}`;
    const currentIndex = $b4e14b6b8da86996$var$choices.findIndex((item)=>item.id === choice.id);
    const hasNextLevel = $b4e14b6b8da86996$var$choices[currentIndex + 1] !== undefined;
    $b4e14b6b8da86996$var$nextLevelButton.disabled = !hasNextLevel;
    $b4e14b6b8da86996$var$nextLevelButton.textContent = hasNextLevel ? "Niveau suivant" : "Dernier niveau";
    if (!$b4e14b6b8da86996$var$victoryDialog.open) $b4e14b6b8da86996$var$victoryDialog.showModal();
}
function $b4e14b6b8da86996$var$updateCounters() {
    $b4e14b6b8da86996$var$initialCount.textContent = $b4e14b6b8da86996$var$selectedLevel?.minimumMoves === null || $b4e14b6b8da86996$var$selectedLevel === null ? "\u2014" : String($b4e14b6b8da86996$var$selectedLevel.minimumMoves);
    $b4e14b6b8da86996$var$playedCount.textContent = String($b4e14b6b8da86996$var$playedActions);
    $b4e14b6b8da86996$var$remainingCount.textContent = $b4e14b6b8da86996$var$solving ? "\u2026" : $b4e14b6b8da86996$var$remainingActions === null ? "\u2014" : String($b4e14b6b8da86996$var$remainingActions);
    $b4e14b6b8da86996$var$projectedCount.textContent = $b4e14b6b8da86996$var$solving || $b4e14b6b8da86996$var$remainingActions === null ? "\u2014" : String($b4e14b6b8da86996$var$playedActions + $b4e14b6b8da86996$var$remainingActions);
}
function $b4e14b6b8da86996$var$updateSolverDisplay() {
    $b4e14b6b8da86996$var$hintButton.disabled = $b4e14b6b8da86996$var$hint === null;
    $b4e14b6b8da86996$var$updateCounters();
    $b4e14b6b8da86996$var$renderBoard();
    if ($b4e14b6b8da86996$var$remainingActions === null) $b4e14b6b8da86996$var$setStatus("Aucune solution n\u2019existe depuis cette position.");
    else if ($b4e14b6b8da86996$var$remainingActions === 0) $b4e14b6b8da86996$var$setStatus("Niveau r\xe9solu !");
    else $b4e14b6b8da86996$var$setStatus(`${$b4e14b6b8da86996$var$remainingActions} action${$b4e14b6b8da86996$var$remainingActions > 1 ? "s" : ""} au minimum depuis cette position.`);
}
function $b4e14b6b8da86996$var$matchesCurrentGame(step) {
    return $b4e14b6b8da86996$var$game !== null && step.lastPieceIndex === $b4e14b6b8da86996$var$lastPieceIndex && step.pieces.length === $b4e14b6b8da86996$var$game.pieces.length && step.pieces.every((piece, index)=>{
        const currentPiece = $b4e14b6b8da86996$var$game?.pieces[index];
        return currentPiece !== undefined && currentPiece.position.x === piece.x && currentPiece.position.y === piece.y;
    });
}
function $b4e14b6b8da86996$var$reuseSolutionPath() {
    const step = $b4e14b6b8da86996$var$solutionPath.find($b4e14b6b8da86996$var$matchesCurrentGame);
    if (step === undefined) return false;
    $b4e14b6b8da86996$var$solving = false;
    $b4e14b6b8da86996$var$remainingActions = step.remainingActions;
    $b4e14b6b8da86996$var$hint = step.hint;
    $b4e14b6b8da86996$var$updateSolverDisplay();
    return true;
}
function $b4e14b6b8da86996$var$arrowForHint(value) {
    if (value.deltaX < 0) return "\u2190";
    if (value.deltaX > 0) return "\u2192";
    if (value.deltaY < 0) return "\u2191";
    return "\u2193";
}
function $b4e14b6b8da86996$var$renderBoard() {
    $b4e14b6b8da86996$var$board.replaceChildren();
    if ($b4e14b6b8da86996$var$game === null) return;
    const currentGame = $b4e14b6b8da86996$var$game;
    $b4e14b6b8da86996$var$board.style.setProperty("--board-width", String(currentGame.width));
    $b4e14b6b8da86996$var$board.style.setProperty("--board-height", String(currentGame.height));
    $b4e14b6b8da86996$var$board.style.aspectRatio = `${currentGame.width} / ${currentGame.height}`;
    if ($b4e14b6b8da86996$var$selectedLevel !== null) {
        const mainPiece = currentGame.pieces.find((piece)=>piece.isMain);
        if (mainPiece !== undefined) {
            const targetWidth = Math.max(...mainPiece.positions.map((position)=>position.x)) - mainPiece.position.x + 1;
            const targetHeight = Math.max(...mainPiece.positions.map((position)=>position.y)) - mainPiece.position.y + 1;
            const target = document.createElement("div");
            target.className = "escape-target";
            target.setAttribute("role", "img");
            target.setAttribute("aria-label", "Position cible de la pi\xe8ce principale");
            target.style.left = `${$b4e14b6b8da86996$var$selectedLevel.escapePoint.x / currentGame.width * 100}%`;
            target.style.top = `${$b4e14b6b8da86996$var$selectedLevel.escapePoint.y / currentGame.height * 100}%`;
            target.style.width = `${targetWidth / currentGame.width * 100}%`;
            target.style.height = `${targetHeight / currentGame.height * 100}%`;
            $b4e14b6b8da86996$var$board.append(target);
        }
    }
    currentGame.pieces.forEach((piece, pieceIndex)=>{
        const width = Math.max(...piece.positions.map((position)=>position.x)) - piece.position.x + 1;
        const height = Math.max(...piece.positions.map((position)=>position.y)) - piece.position.y + 1;
        const pieceElement = document.createElement("button");
        pieceElement.type = "button";
        pieceElement.className = `piece${piece.isMain ? " main" : ""}${$b4e14b6b8da86996$var$hintVisible && $b4e14b6b8da86996$var$hint?.pieceIndex === pieceIndex ? " hinted" : ""}`;
        pieceElement.style.left = `${piece.position.x / currentGame.width * 100}%`;
        pieceElement.style.top = `${piece.position.y / currentGame.height * 100}%`;
        pieceElement.style.width = `${width / currentGame.width * 100}%`;
        pieceElement.style.height = `${height / currentGame.height * 100}%`;
        pieceElement.setAttribute("aria-label", `${piece.isMain ? "Pi\xe8ce principale" : "Pi\xe8ce"} ligne ${piece.position.y + 1}, colonne ${piece.position.x + 1}`);
        const symbol = document.createElement("span");
        symbol.className = "piece-symbol";
        symbol.textContent = piece.isMain ? "\u66F9" : "";
        pieceElement.append(symbol);
        const arrow = document.createElement("span");
        arrow.className = "hint-arrow";
        arrow.textContent = $b4e14b6b8da86996$var$hintVisible && $b4e14b6b8da86996$var$hint?.pieceIndex === pieceIndex ? $b4e14b6b8da86996$var$arrowForHint($b4e14b6b8da86996$var$hint) : "";
        pieceElement.append(arrow);
        pieceElement.addEventListener("pointerdown", (event)=>{
            $b4e14b6b8da86996$var$beginDrag(event, pieceElement, pieceIndex);
        });
        $b4e14b6b8da86996$var$board.append(pieceElement);
    });
}
function $b4e14b6b8da86996$var$beginDrag(event, element, pieceIndex) {
    if ($b4e14b6b8da86996$var$game === null) return;
    const piece = $b4e14b6b8da86996$var$game.pieces[pieceIndex];
    if (piece === undefined) return;
    event.preventDefault();
    element.setPointerCapture(event.pointerId);
    element.classList.add("dragging");
    $b4e14b6b8da86996$var$drag = {
        element: element,
        pieceIndex: pieceIndex,
        pointerId: event.pointerId,
        anchorX: event.clientX,
        anchorY: event.clientY,
        originalX: piece.position.x,
        originalY: piece.position.y,
        cellWidth: $b4e14b6b8da86996$var$board.clientWidth / $b4e14b6b8da86996$var$game.width,
        cellHeight: $b4e14b6b8da86996$var$board.clientHeight / $b4e14b6b8da86996$var$game.height,
        hasMoved: false
    };
    element.addEventListener("pointermove", $b4e14b6b8da86996$var$moveDrag);
    element.addEventListener("pointerup", $b4e14b6b8da86996$var$endDrag);
    element.addEventListener("pointercancel", $b4e14b6b8da86996$var$cancelDrag);
}
function $b4e14b6b8da86996$var$moveDrag(event) {
    if ($b4e14b6b8da86996$var$drag === null || event.pointerId !== $b4e14b6b8da86996$var$drag.pointerId || $b4e14b6b8da86996$var$game === null) return;
    const activeDrag = $b4e14b6b8da86996$var$drag;
    const piece = $b4e14b6b8da86996$var$game.pieces[activeDrag.pieceIndex];
    if (piece === undefined) return;
    const maximumSteps = $b4e14b6b8da86996$var$game.width + $b4e14b6b8da86996$var$game.height;
    for(let attempt = 0; attempt < maximumSteps; attempt += 1){
        const deltaX = event.clientX - activeDrag.anchorX;
        const deltaY = event.clientY - activeDrag.anchorY;
        const horizontalDistance = Math.abs(deltaX) / activeDrag.cellWidth;
        const verticalDistance = Math.abs(deltaY) / activeDrag.cellHeight;
        if (Math.max(horizontalDistance, verticalDistance) < 0.45) break;
        const horizontalFirst = horizontalDistance >= verticalDistance;
        const candidates = horizontalFirst ? [
            [
                Math.sign(deltaX),
                0
            ],
            [
                0,
                Math.sign(deltaY)
            ]
        ] : [
            [
                0,
                Math.sign(deltaY)
            ],
            [
                Math.sign(deltaX),
                0
            ]
        ];
        let moved = false;
        for (const [stepX, stepY] of candidates){
            const relevantDistance = stepX === 0 ? verticalDistance : horizontalDistance;
            if (relevantDistance < 0.45 || stepX === 0 && stepY === 0 || !$b4e14b6b8da86996$var$game.canMoveTo(piece, stepX, stepY)) continue;
            piece.move(stepX, stepY);
            activeDrag.anchorX += stepX * activeDrag.cellWidth;
            activeDrag.anchorY += stepY * activeDrag.cellHeight;
            activeDrag.hasMoved = true;
            $b4e14b6b8da86996$var$positionDraggedElement(activeDrag.element, piece, $b4e14b6b8da86996$var$game);
            moved = true;
            break;
        }
        if (!moved) break;
    }
}
function $b4e14b6b8da86996$var$positionDraggedElement(element, piece, currentGame) {
    element.style.left = `${piece.position.x / currentGame.width * 100}%`;
    element.style.top = `${piece.position.y / currentGame.height * 100}%`;
}
function $b4e14b6b8da86996$var$clearDragListeners() {
    if ($b4e14b6b8da86996$var$drag === null) return;
    $b4e14b6b8da86996$var$drag.element.removeEventListener("pointermove", $b4e14b6b8da86996$var$moveDrag);
    $b4e14b6b8da86996$var$drag.element.removeEventListener("pointerup", $b4e14b6b8da86996$var$endDrag);
    $b4e14b6b8da86996$var$drag.element.removeEventListener("pointercancel", $b4e14b6b8da86996$var$cancelDrag);
    $b4e14b6b8da86996$var$drag.element.classList.remove("dragging");
}
function $b4e14b6b8da86996$var$cancelDrag(event) {
    if ($b4e14b6b8da86996$var$drag === null || event.pointerId !== $b4e14b6b8da86996$var$drag.pointerId || $b4e14b6b8da86996$var$game === null) return;
    const activeDrag = $b4e14b6b8da86996$var$drag;
    const piece = $b4e14b6b8da86996$var$game.pieces[activeDrag.pieceIndex];
    if (piece !== undefined && activeDrag.hasMoved) piece.move(activeDrag.originalX - piece.position.x, activeDrag.originalY - piece.position.y);
    $b4e14b6b8da86996$var$clearDragListeners();
    $b4e14b6b8da86996$var$drag = null;
    $b4e14b6b8da86996$var$renderBoard();
}
function $b4e14b6b8da86996$var$endDrag(event) {
    if ($b4e14b6b8da86996$var$drag === null || event.pointerId !== $b4e14b6b8da86996$var$drag.pointerId || $b4e14b6b8da86996$var$game === null) return;
    const activeDrag = $b4e14b6b8da86996$var$drag;
    $b4e14b6b8da86996$var$clearDragListeners();
    $b4e14b6b8da86996$var$drag = null;
    if (!activeDrag.hasMoved) {
        $b4e14b6b8da86996$var$renderBoard();
        return;
    }
    if ($b4e14b6b8da86996$var$lastPieceIndex !== activeDrag.pieceIndex) $b4e14b6b8da86996$var$playedActions += 1;
    $b4e14b6b8da86996$var$lastPieceIndex = activeDrag.pieceIndex;
    $b4e14b6b8da86996$var$hint = null;
    $b4e14b6b8da86996$var$renderBoard();
    if ($b4e14b6b8da86996$var$selectedLevel !== null && $b4e14b6b8da86996$var$game.isWinningGame($b4e14b6b8da86996$var$selectedLevel.escapePoint.x, $b4e14b6b8da86996$var$selectedLevel.escapePoint.y)) {
        $b4e14b6b8da86996$var$solver?.terminate();
        $b4e14b6b8da86996$var$solver = null;
        $b4e14b6b8da86996$var$latestRequestId += 1;
        $b4e14b6b8da86996$var$remainingActions = 0;
        $b4e14b6b8da86996$var$solving = false;
        $b4e14b6b8da86996$var$solutionPath = [];
        $b4e14b6b8da86996$var$updateCounters();
        $b4e14b6b8da86996$var$setStatus("Niveau r\xe9solu ! La pi\xe8ce principale est libre.");
        $b4e14b6b8da86996$var$hintButton.disabled = true;
        $b4e14b6b8da86996$var$showVictoryScreen();
        return;
    }
    if ($b4e14b6b8da86996$var$reuseSolutionPath()) return;
    $b4e14b6b8da86996$var$solvePosition();
}
function $b4e14b6b8da86996$var$serializeGame(requestId) {
    if ($b4e14b6b8da86996$var$game === null || $b4e14b6b8da86996$var$selectedLevel === null) throw new Error("Cannot solve a game before selecting a level");
    return {
        requestId: requestId,
        width: $b4e14b6b8da86996$var$game.width,
        height: $b4e14b6b8da86996$var$game.height,
        pieces: $b4e14b6b8da86996$var$game.pieces.map((piece)=>({
                x: piece.position.x,
                y: piece.position.y,
                pieceType: piece.pieceType,
                isMain: piece.isMain
            })),
        lastPieceIndex: $b4e14b6b8da86996$var$lastPieceIndex,
        targetX: $b4e14b6b8da86996$var$selectedLevel.escapePoint.x,
        targetY: $b4e14b6b8da86996$var$selectedLevel.escapePoint.y
    };
}
var $dc33563e94ff3c77$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $dc33563e94ff3c77$var$url = new URL(import.meta.resolve("bJhu4"));
$dc33563e94ff3c77$exports = $56b621a6dd25b2cb$exports($dc33563e94ff3c77$var$url.toString(), $dc33563e94ff3c77$var$url.origin, true);


async function $b4e14b6b8da86996$var$solvePosition() {
    if ($b4e14b6b8da86996$var$game === null || $b4e14b6b8da86996$var$selectedLevel === null) return;
    $b4e14b6b8da86996$var$solutionPath = [];
    $b4e14b6b8da86996$var$solving = true;
    $b4e14b6b8da86996$var$remainingActions = null;
    $b4e14b6b8da86996$var$hint = null;
    $b4e14b6b8da86996$var$hintButton.disabled = true;
    $b4e14b6b8da86996$var$latestRequestId += 1;
    $b4e14b6b8da86996$var$updateCounters();
    $b4e14b6b8da86996$var$setStatus("Le solveur analyse cette position\u2026");
    $b4e14b6b8da86996$var$solver?.terminate();
    $b4e14b6b8da86996$var$solver = new Worker($dc33563e94ff3c77$exports);
    $b4e14b6b8da86996$var$solver.addEventListener("message", $b4e14b6b8da86996$var$handleSolverResult);
    $b4e14b6b8da86996$var$solver.addEventListener("error", $b4e14b6b8da86996$var$handleSolverError);
    $b4e14b6b8da86996$var$solver.postMessage($b4e14b6b8da86996$var$serializeGame($b4e14b6b8da86996$var$latestRequestId));
}
function $b4e14b6b8da86996$var$handleSolverResult(event) {
    if (event.data.requestId !== $b4e14b6b8da86996$var$latestRequestId) return;
    $b4e14b6b8da86996$var$solutionPath = event.data.path;
    const firstStep = $b4e14b6b8da86996$var$solutionPath[0];
    $b4e14b6b8da86996$var$solving = false;
    $b4e14b6b8da86996$var$remainingActions = firstStep?.remainingActions ?? null;
    $b4e14b6b8da86996$var$hint = firstStep?.hint ?? null;
    $b4e14b6b8da86996$var$updateSolverDisplay();
}
function $b4e14b6b8da86996$var$handleSolverError(event) {
    $b4e14b6b8da86996$var$solutionPath = [];
    $b4e14b6b8da86996$var$solving = false;
    $b4e14b6b8da86996$var$hintButton.disabled = true;
    $b4e14b6b8da86996$var$updateCounters();
    $b4e14b6b8da86996$var$setStatus(`Le solveur a \xe9chou\xe9 : ${event.message}`);
}
function $b4e14b6b8da86996$var$selectLevel(choice) {
    if ($b4e14b6b8da86996$var$victoryDialog.open) $b4e14b6b8da86996$var$victoryDialog.close();
    $b4e14b6b8da86996$var$selectedLevel = choice.level;
    $b4e14b6b8da86996$var$game = $b4e14b6b8da86996$var$cloneGame(choice.level.game);
    $b4e14b6b8da86996$var$solutionPath = [];
    $b4e14b6b8da86996$var$playedActions = 0;
    $b4e14b6b8da86996$var$remainingActions = choice.level.minimumMoves;
    $b4e14b6b8da86996$var$lastPieceIndex = null;
    $b4e14b6b8da86996$var$hint = null;
    $b4e14b6b8da86996$var$resetButton.disabled = false;
    $b4e14b6b8da86996$var$hintButton.disabled = true;
    $b4e14b6b8da86996$var$renderBoard();
    $b4e14b6b8da86996$var$updateCounters();
    $b4e14b6b8da86996$var$solvePosition();
}
function $b4e14b6b8da86996$var$populateLevelSelect() {
    $b4e14b6b8da86996$var$levelSelect.replaceChildren();
    for (const collection of $b4e14b6b8da86996$var$COLLECTIONS){
        const groupChoices = $b4e14b6b8da86996$var$choices.filter((choice)=>choice.collection === collection.file);
        if (groupChoices.length === 0) continue;
        const group = document.createElement("optgroup");
        group.label = collection.label;
        for (const choice of groupChoices){
            const option = document.createElement("option");
            option.value = choice.id;
            $b4e14b6b8da86996$var$updateLevelOption(option, choice);
            group.append(option);
        }
        $b4e14b6b8da86996$var$levelSelect.append(group);
    }
    $b4e14b6b8da86996$var$levelSelect.disabled = $b4e14b6b8da86996$var$choices.length === 0;
}
function $b4e14b6b8da86996$var$exportProgress() {
    const blob = new Blob([
        (0, $731f0200f14e0930$export$fb183d491ecd1d5e)($b4e14b6b8da86996$var$progress)
    ], {
        type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "klotski-save.json";
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    $b4e14b6b8da86996$var$setStatus("Sauvegarde export\xe9e.");
}
async function $b4e14b6b8da86996$var$importProgress(file) {
    try {
        const importedProgress = (0, $731f0200f14e0930$export$f70ecbe02728c625)(JSON.parse(await file.text()));
        localStorage.setItem($b4e14b6b8da86996$var$SAVE_STORAGE_KEY, (0, $731f0200f14e0930$export$fb183d491ecd1d5e)(importedProgress));
        $b4e14b6b8da86996$var$progress = importedProgress;
        $b4e14b6b8da86996$var$refreshLevelOptions();
        const nextChoice = $b4e14b6b8da86996$var$preferredChoice();
        if (nextChoice !== undefined) {
            $b4e14b6b8da86996$var$levelSelect.value = nextChoice.id;
            $b4e14b6b8da86996$var$selectLevel(nextChoice);
        }
        const count = $b4e14b6b8da86996$var$progress.size;
        $b4e14b6b8da86996$var$setStatus(`Sauvegarde import\xe9e : ${count} niveau${count > 1 ? "x" : ""} r\xe9solu${count > 1 ? "s" : ""}.`);
    } catch (error) {
        console.error(`Impossible d\u{2019}importer la sauvegarde : ${$b4e14b6b8da86996$var$errorMessage(error)}`);
        $b4e14b6b8da86996$var$setStatus("Le fichier de sauvegarde est invalide ou inaccessible.");
    }
}
$b4e14b6b8da86996$var$levelSelect.addEventListener("change", ()=>{
    const choice = $b4e14b6b8da86996$var$choices.find((item)=>item.id === $b4e14b6b8da86996$var$levelSelect.value);
    if (choice !== undefined) $b4e14b6b8da86996$var$selectLevel(choice);
});
$b4e14b6b8da86996$var$resetButton.addEventListener("click", ()=>{
    const choice = $b4e14b6b8da86996$var$choices.find((item)=>item.id === $b4e14b6b8da86996$var$levelSelect.value);
    if (choice !== undefined) $b4e14b6b8da86996$var$selectLevel(choice);
});
$b4e14b6b8da86996$var$hintButton.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$hintVisible = !$b4e14b6b8da86996$var$hintVisible;
    $b4e14b6b8da86996$var$hintButton.textContent = $b4e14b6b8da86996$var$hintVisible ? "Masquer l\u2019indice" : "Afficher l\u2019indice";
    $b4e14b6b8da86996$var$renderBoard();
});
$b4e14b6b8da86996$var$exportSaveButton.addEventListener("click", $b4e14b6b8da86996$var$exportProgress);
$b4e14b6b8da86996$var$importSaveButton.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$saveFileInput.click();
});
$b4e14b6b8da86996$var$saveFileInput.addEventListener("change", ()=>{
    const file = $b4e14b6b8da86996$var$saveFileInput.files?.[0];
    $b4e14b6b8da86996$var$saveFileInput.value = "";
    if (file !== undefined) $b4e14b6b8da86996$var$importProgress(file);
});
$b4e14b6b8da86996$var$nextLevelButton.addEventListener("click", ()=>{
    const choice = $b4e14b6b8da86996$var$currentChoice();
    if (choice === undefined) return;
    const currentIndex = $b4e14b6b8da86996$var$choices.findIndex((item)=>item.id === choice.id);
    const nextChoice = $b4e14b6b8da86996$var$choices[currentIndex + 1];
    if (nextChoice === undefined) return;
    $b4e14b6b8da86996$var$levelSelect.value = nextChoice.id;
    $b4e14b6b8da86996$var$selectLevel(nextChoice);
});
$b4e14b6b8da86996$var$closeVictoryButton.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$victoryDialog.close();
});
async function $b4e14b6b8da86996$var$start() {
    const collections = await Promise.all($b4e14b6b8da86996$var$COLLECTIONS.map(async (collection)=>({
            collection: collection,
            levels: await (0, $e34a31c9fa062692$export$8f449e88c069ccfc)(collection.file)
        })));
    $b4e14b6b8da86996$var$choices = collections.flatMap(({ collection: collection, levels: levels })=>levels.map((level)=>({
                id: `${collection.file}:${level.level}`,
                collection: collection.file,
                level: level
            })));
    $b4e14b6b8da86996$var$populateLevelSelect();
    const nextChoice = $b4e14b6b8da86996$var$preferredChoice();
    if (nextChoice === undefined) {
        $b4e14b6b8da86996$var$setStatus("Aucun niveau valide n\u2019a pu \xeatre charg\xe9.");
        return;
    }
    $b4e14b6b8da86996$var$levelSelect.value = nextChoice.id;
    $b4e14b6b8da86996$var$selectLevel(nextChoice);
}
$b4e14b6b8da86996$var$start();


//# sourceMappingURL=www.ee57450b.js.map
